import { useGetGroupedVersionHistory } from "../../../../api/versionHistory/versionHistory";
import { VersionHistoryGroup } from "../types/versionHistory.types";

export function useGroupedVersionHistory(params: {
  productId: string | undefined;
  salesUnitId: string | undefined;
  pageNumber: number;
  pageSize: number;
  enabled: boolean;
}) {
  const { data, isLoading, isFetching, isError, refetch } = useGetGroupedVersionHistory(
    {
      productId: params.productId,
      salesUnitId: params.salesUnitId,
      pageNumber: params.pageNumber,
      pageSize: params.pageSize
    },
    params.enabled
  );

  const versions: VersionHistoryGroup[] = data?.result?.groups ?? [];

  return {
    versions,
    total: data?.total ?? 0,
    isLoading,
    isFetching,
    isError,
    refetch
  };
}
